import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { MailboxInfo } from 'owa-client-types';
import { logUsage } from 'owa-analytics';
import { getItem, itemExists } from 'owa-local-storage';
import { USER_OCPS_POLICY_STORE } from './constants';
import type { OcpsPolicyStore } from '../store/schema/OcpsPolicyStore';
import { updateOcpsLocalStorage } from './updateOcpsLocalStorage';

export function onAccountRemoved(mailboxInfo: MailboxInfo): void {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    let ocpsPolicyStore: OcpsPolicyStore;

    if (itemExists(window, USER_OCPS_POLICY_STORE)) {
        ocpsPolicyStore = JSON.parse(
            getItem(window, USER_OCPS_POLICY_STORE) ?? JSON.stringify(null)
        );

        if (ocpsPolicyStore.policies[accountKey]) {
            delete ocpsPolicyStore.policies[accountKey];
            updateOcpsLocalStorage(ocpsPolicyStore);

            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logUsage('OcpsStore_AccountRemoved', undefined);
        }
    }
}
